jQuery(document).ready(function($){
  	$('.mMenu').on('click',function(){
    	//$('.menu-mainmenu-container').slideToggle(300);
  	});

	// Language open  	
  	$('.mapToggle').on('click', function(){
    	$('#lang_sel_list').toggleClass('open');
    	$('.langSwitch').toggleClass('open');
	});
	// Check language and add class
	var lang = document.documentElement.lang;
	if (lang === 'sv-SE'){
		$('.langSwitch').addClass('sv');
		$('.langSwitch').removeClass('en');
	} else {
		$('.langSwitch').addClass('en');
		$('.langSwitch').removeClass('sv');
	}

  	$(".formSelect").click(function () {
  	  var val = $(this).attr('data-value');
  	  $('.ginput_container_select').find('select').val(val);
  
	});



	// Header scroll function
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	//var navbarHeight = $('#site-header').outerHeight();
  	var navbarHeight = 0;
		$(window).scroll(function(event){
		didScroll = true;

	});
	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0);
	function hasScrolled() {
		var st = $(this).scrollTop();
		if (st==0) {

			if($("body").hasClass("menuOpen")) {
				$('#site-header').addClass('scrolled white-menu');
			}
			else {
				$('#site-header').removeClass('scrolled white-menu');
				$('#site-header').removeClass('scroll-down');
			}

		}
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
		return;
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down
			$('#site-header').removeClass('scroll-up').addClass('scrolled');
			setTimeout(function () {
				$('#site-header').addClass('scroll-down');
			}, 0);
		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('#site-header').addClass('scroll-up');
			}
		}
		lastScrollTop = st;
	}

	  
});
jQuery(document).ready(function($){
	// Class on header when navigaion is active on mobile
	$('#site-header .mMenu .menu-line').on('click',function(){
		if (!$( '#site-header').hasClass( "navOpen" )){
			$('#site-header').addClass("navOpen");
		} else {
			setTimeout(function(){ 
				$('#site-header').removeClass("navOpen");
			}, 370);
		}
	});

	$('.other-menu-header').each(function () {

		$(this).on('click', function () {

			$(this).toggleClass('active');
			$(this).next().toggle();

		});

	});
});
